import { __awaiter, __generator, __assign } from '../../_virtual/_tslib.js';
import { defineComponent, ref, computed, onMounted, onUnmounted, nextTick } from '@vue/composition-api';
import __vue_component__ from '../SdsInputSearch/SdsInputSearch.vue.js';
import __vue_component__$1 from '../SdsContentLoader/SdsContentLoader.vue.js';
import __vue_component__$2 from '../SdsIcon/SdsIcon.vue.js';

var script = defineComponent({
    props: {
        size: {
            type: String,
            required: false,
            default: 'lg',
        },
        label: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            required: false,
            default: undefined,
        },
        areOptionsLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
        hasNoResults: {
            type: Boolean,
            required: false,
            default: false,
        },
        options: {
            type: Array,
            required: true,
        },
        selectedOption: {
            type: String,
            required: false,
            default: undefined,
        },
        query: {
            type: String,
            required: false,
            default: '',
        },
        isItemDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        isSearchable: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    emits: [
        'update:query',
        'update:selectedOption',
        'close:esc'
    ],
    setup: function (props, _a) {
        var _this = this;
        var emit = _a.emit;
        var selectedItem = ref(null);
        var currentOptionIndex = -1;
        var contentLoaderSize = computed(function () {
            switch (props.size) {
                case 'lg':
                    return 'md';
                case 'md':
                    return 'sm';
                case 'sm':
                    return 'xs';
            }
        });
        function scrollIntoView() {
            var _a;
            var overlaySelect = document.querySelector('.sds-overlay-select');
            var item = ((_a = Object.values(__assign({}, selectedItem.value))) === null || _a === void 0 ? void 0 : _a[0]) || null;
            if (overlaySelect && item) {
                var itemOffset = props.size === 'md' ? item.offsetTop - 60 : item.offsetTop;
                overlaySelect.scrollTo({
                    top: itemOffset,
                    behavior: 'auto',
                });
            }
        }
        function moveFocusDown() {
            if (currentOptionIndex < props.options.length - 1) {
                currentOptionIndex++;
            }
            else {
                currentOptionIndex = 0;
            }
            focusCurrentOption();
        }
        function moveFocusUp() {
            if (currentOptionIndex > 0) {
                currentOptionIndex--;
            }
            else {
                currentOptionIndex = props.options.length - 1;
            }
            focusCurrentOption();
        }
        var focusCurrentOption = function () {
            var currentOption = document.querySelector(".sds-overlay-select__item[data-index=\"".concat(currentOptionIndex, "\"]"));
            currentOption === null || currentOption === void 0 ? void 0 : currentOption.focus();
        };
        var keyFunctions = function (e) {
            switch (e.code) {
                case 'ArrowDown':
                    moveFocusDown();
                    break;
                case 'ArrowUp':
                    moveFocusUp();
                    break;
                case 'Escape':
                    emit('close:esc', e);
                    break;
            }
        };
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        scrollIntoView();
                        document.addEventListener('keydown', keyFunctions);
                        return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () {
            document.removeEventListener('keydown', keyFunctions);
        });
        return {
            contentLoaderSize: contentLoaderSize,
            selectedItem: selectedItem,
            moveFocusDown: moveFocusDown,
            moveFocusUp: moveFocusUp,
        };
    },
    components: {
        SdsInputSearch: __vue_component__,
        SdsContentLoader: __vue_component__$1,
        SdsIcon: __vue_component__$2,
    },
});

export default script;
